import React from 'react';
import Container from '../container';
import styled, { css } from 'styled-components';
import StatItem from '../logo-marquee-with-title-and-stats/StatItem';
import BenefitItem from './BenefitItem';
import mq from '../../utils/mq';

const ProjectResultsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;
  width: 100%;
  padding: 96px 0;
  ${mq.mobile(css`
    padding: 42px 0;
    display: flex;
    flex-direction: column;
  `)};
`;

const ProjectResultsContentContainer = styled.div`
  grid-column: 2 / span 10;
`;

const LabelContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const LabelText = styled.div`
  color: #666;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: -0.15px;
`;

const LabelDecoration = styled.div`
  background: #813dff;
  width: 16px;
  height: 2px;
`;

const Title = styled.div`
  color: #161616;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  letter-spacing: -0.72px;
  padding-top: 22px;
  ${mq.mobile(css`
    font-size: 32px;
  `)};
`;

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 48px;
  align-items: start;
  padding-top: 64px;
  padding-bottom: 80px;
  ${mq.mobile(css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-top: 42px;
    padding-bottom: 42px;
  `)}
`;

const BenefitsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 48px;
  grid-row-gap: 56px;
  padding-top: 64px;
  ${mq.mobile(css`
    display: flex;
    flex-direction: column;
    grid-row-gap: 42px;
    padding-top: 42px;
  `)};
`;

export default function CaseStudyProjectResults({
  title,
  statItems,
  benefitsTitle,
  benefitItems
}: {
  title: string;
  statItems: any[];
  benefitsTitle: string;
  benefitItems: any[];
}) {
  return (
    <Container>
      <ProjectResultsGrid>
        <ProjectResultsContentContainer>
          <LabelContainer>
            <LabelText>The Results</LabelText>
            <LabelDecoration />
          </LabelContainer>
          <Title>{title}</Title>
          <StatsContainer>
            {statItems?.map((stat, i) => (
              <StatItem key={i} {...stat} />
            ))}
          </StatsContainer>

          <Title>{benefitsTitle}</Title>
          <BenefitsContainer>
            {benefitItems?.map((benefit, i) => (
              <BenefitItem {...benefit} key={i} />
            ))}
          </BenefitsContainer>
        </ProjectResultsContentContainer>
      </ProjectResultsGrid>
    </Container>
  );
}
